import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { TextField } from '@totalsoft/rocket-ui';
import { ParamsContext } from 'providers/ParamsContext';

export const OfferFeeCatalogListItemComponent = ({ t, fee, editRight, onPropertyChange, idx }) => {
  const { cvsChPercent } = useContext(ParamsContext);
  return (
    <React.Fragment>
      <Grid container spacing={1}>
        <Grid item xs={12} md={3} sm={4}>
          <TextField
            id={'offerFeeCatalogCard_' + idx + '_name'}
            label={t('OfferEdit.FeeCatalog.Fee')}
            name={'name'}
            fullWidth
            value={!fee || !fee.name ? '' : fee.name}
            disabled={true}
          />
        </Grid>
        <Grid item xs={12} md={3} sm={4}>
          <TextField
            id={'offerFeeCatalogCard_' + idx + '_percent'}
            label={t('OfferEdit.FeeCatalog.Percent')}
            name={'percent'}
            fullWidth
            isNumeric
            value={!fee || (!fee.percent && fee.percent !== 0) ? '' : t('NUMBER', { number: fee.percent })}
            onChange={onPropertyChange('percent')}
            inputProps={{ decimalScale: cvsChPercent }}
            disabled={!editRight}
          />
        </Grid>
        {fee.showAmount && (
          <Grid item xs={12} md={3} sm={4}>
            <TextField
              id={'offerFeeCatalogCard_' + idx + '_value'}
              label={t('OfferEdit.FeeCatalog.Value', { currencyCode: fee.currencyCode })}
              name='value'
              fullWidth
              isNumeric
              value={!fee || (!fee.value && fee.value !== 0) ? '' : fee.value}
              onChange={onPropertyChange('value')}
              disabled={!editRight}
            />
          </Grid>
        )}
      </Grid>
    </React.Fragment>
  );
};

OfferFeeCatalogListItemComponent.propTypes = {
  fee: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  idx: PropTypes.number.isRequired,
  editRight: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired
};

export default compose(withTranslation()(OfferFeeCatalogListItemComponent));
